module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skills-want"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._m(0), _vm._v(" "), (this.$parent.bigIdea) ? _c('p', {
    staticClass: "idea"
  }, [_vm._v("\"" + _vm._s(this.$parent.bigIdea) + "\"")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search Skills...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.govAndIntDevSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showGov
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showGov')
      }
    }
  }, [_vm._v("Governance and International Development")]), _vm._v(" "), (_vm.showGov) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.govAndIntDevSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.commsSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showCom
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showCom')
      }
    }
  }, [_vm._v("Communications")]), _vm._v(" "), (_vm.showCom) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.commsSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.businessSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showBus
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showBus')
      }
    }
  }, [_vm._v("Business")]), _vm._v(" "), (_vm.showBus) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.businessSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.designSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showDes
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showDes')
      }
    }
  }, [_vm._v("Design and Creativity")]), _vm._v(" "), (_vm.showDes) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.designSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.leadershipSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showLea
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showLea')
      }
    }
  }, [_vm._v("Leadership and Management")]), _vm._v(" "), (_vm.showLea) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.leadershipSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.analyticSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showAna
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showAna')
      }
    }
  }, [_vm._v("Analysis and Research")]), _vm._v(" "), (_vm.showAna) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.analyticSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.techSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showTec
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showTec')
      }
    }
  }, [_vm._v("Technical and Information Skills")]), _vm._v(" "), (_vm.showTec) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.techSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.legalSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showLeg
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showLeg')
      }
    }
  }, [_vm._v("Legal")]), _vm._v(" "), (_vm.showLeg) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.legalSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stemSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showSte
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showSte')
      }
    }
  }, [_vm._v("STEM (science, technology, engineering and mathematics)")]), _vm._v(" "), (_vm.showSte) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.stemSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change your Big Idea")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Choose between "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("three")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ten")]), _vm._v(" skills you need to make your big idea happen.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2449ddbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-9.vue
// module id = 693
// module chunks = 1